import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { JourneyCreateInput } from "./types";

export type CreateJourneyResponse = { id: string };

// POST /api/admin/journeys
//
// Replaces /app/admin/journeys/_actions.ts::createJourneyAction. Pessimistic
// (matches bucket-5 use-create-form). Caller routes to
// /admin/journeys/[id]/edit on success.
export function useCreateJourney() {
  const queryClient = useQueryClient();
  return useMutation<CreateJourneyResponse, ApiClientError, JourneyCreateInput>({
    mutationFn: (input) =>
      apiFetch<CreateJourneyResponse>("/admin/journeys", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.journeys.list() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to create journey");
    },
  });
}
